<template>
  <div class="schedule__total row">
    <div class="col-12"></div>
    <div class="col-12 col-md-9 offset-md-3">
      <div class="schedule__total-primary text-right">
        Total: Php
        {{ total }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: [Number, String],
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.schedule {
  &__total {
    &-primary {
      background-color: $gray-200;
      padding: 18px;
      font-size: 15px;
      font-weight: 500;
    }
  }
}
</style>
